import { Injectable } from "@angular/core";
import { LoadingOverlayRef } from "../../loading/loading-overlay-ref";
import { IFileExportOrderRequest, ISasFileExportRequest } from "./file-export-order-request";
import { IFileFileExportResult } from "./file-export-result";

@Injectable()
export class FileExportProcessor {
  private static readonly DefaultIntervalInMillis: number = 5000;

  private readonly intervalInMillis: number = FileExportProcessor.DefaultIntervalInMillis;

  constructor() { }

  public async processFile(fileExportOrderRequest: IFileExportOrderRequest, loadingRef: LoadingOverlayRef): Promise<void> {
    if (!fileExportOrderRequest) {
      throw "File export order request cant be null";
    }
    const orderKey = await fileExportOrderRequest.orderExport();
    if (!!orderKey) {
      const intervalHandle = setInterval(async () => {
        try {
          if (await fileExportOrderRequest.isFileExportReady(orderKey)) {
            const fileExportResult: IFileFileExportResult = await fileExportOrderRequest.downloadFile(orderKey);
            if (!!fileExportResult) {
              const name = fileExportOrderRequest.getFileExportName();
              fileExportResult.notifyDownload(name);
              clearInterval(intervalHandle);
              loadingRef.closeLoading();
            }
          }
        } catch (error) {
          fileExportOrderRequest.showError(error);
          clearInterval(intervalHandle);
          loadingRef.closeLoading();
        }
      }, this.intervalInMillis);
    }
  }

  public async processFileBySas(fileExportOrderRequest: ISasFileExportRequest, loadingRef: LoadingOverlayRef): Promise<void> {
    if (!fileExportOrderRequest) {
      throw "File export order request can't be null";
    }

    const orderKey = await fileExportOrderRequest.orderExport();
    if (!!orderKey) {
      const intervalHandle = setInterval(async () => {
        try {
          const status = await fileExportOrderRequest.getExportSasStatus(orderKey);

          if (status.exported && status.downloadUri) {
            fileExportOrderRequest.downloadViaSasLink("gestao-transacional.xlsx", status.downloadUri);
            clearInterval(intervalHandle);
            loadingRef.closeLoading();
          } else if (status.hasError) {
            clearInterval(intervalHandle);
            loadingRef.closeLoading();
            fileExportOrderRequest.showError("Erro ao gerar o arquivo de exportação.");
          }

        } catch (error) {
          clearInterval(intervalHandle);
          loadingRef.closeLoading();
          fileExportOrderRequest.showError(error);
        }
      }, this.intervalInMillis);
    }
  }
}
